const STORAGE_KEY = 'coordal.weatherForecastSubscriptions';

type StoredSubscription = {
  email: string;
  lat: number;
  lng: number;
  subscribedAt: string;
};

function roundCoord(value: number): number {
  return Math.round(value * 1000) / 1000;
}

function locationKey(email: string, lat: number, lng: number): string {
  return `${email.toLowerCase().trim()}:${roundCoord(lat)}:${roundCoord(lng)}`;
}

function readAll(): StoredSubscription[] {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as StoredSubscription[];
    return Array.isArray(parsed) ? parsed : [];
  } catch {
    return [];
  }
}

function writeAll(entries: StoredSubscription[]): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(entries));
}

/** Remember a successful subscribe (including already subscribed) for this map point. */
export function markWeatherForecastSubscribed(email: string, lat: number, lng: number): void {
  const normalized = email.toLowerCase().trim();
  if (!normalized) return;

  const key = locationKey(normalized, lat, lng);
  const next = readAll().filter(
    (e) => locationKey(e.email, e.lat, e.lng) !== key,
  );
  next.push({
    email: normalized,
    lat: roundCoord(lat),
    lng: roundCoord(lng),
    subscribedAt: new Date().toISOString(),
  });
  writeAll(next);
}

export function isWeatherForecastSubscribed(
  email: string | null | undefined,
  lat: number,
  lng: number,
): boolean {
  const normalized = email?.toLowerCase().trim();
  if (!normalized) return false;

  const key = locationKey(normalized, lat, lng);
  return readAll().some((e) => locationKey(e.email, e.lat, e.lng) === key);
}
